import { mutatorAction } from 'satcheljs';
import { CustomPanelType } from '../store';
import { getAppStore } from '../store/store';

export const onPanelTypeChanged = mutatorAction('onDialogTypeChanged', (panelType: CustomPanelType) => {
  getAppStore().openedPanel = panelType;
});
